"use strict";
// @ts-ignore
try {
    self['workbox:background-sync:5.1.4'] && _();
}
catch (e) { }
